module.exports = __webpack_public_path__ + "img/footer-como-jogar.8da430a6.png";